import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/tourisme-montreal-vacances.module.css';

interface TourismeMontrealVacancesProps extends HTMLAttributes<HTMLDivElement> {
    className?: string;
    children: ReactNode;
}

function TourismeMontrealVacancesTheme({
    children,
    className = null,
    ref: containerRef = null,
    ...props
}: TourismeMontrealVacancesProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={containerRef} {...props}>
            {children}
        </div>
    );
}

export default TourismeMontrealVacancesTheme;
